import React from "react";
import { CartIcon, LoginIcon, CallIcon } from "@/components";
import { BurgerMenuButton } from "../BurgerMenuButton/BurgerMenuButton";

import styles from "./HeaderRightButton.module.scss";

interface HeaderRightButtonProps {
  onBurgerClick?: () => void;
  isBurgerOpen?: boolean;
}

export const HeaderRightButton: React.FC<HeaderRightButtonProps> = ({ 
  onBurgerClick, 
  isBurgerOpen = false 
}) => {
  return (
    <div className={styles.icons}>
      <div className={styles.desktopIcons}>
        <CallIcon />
        <CartIcon />
        <LoginIcon />
      </div>
      <div className={styles.mobileIcons}>
        {!isBurgerOpen && (
          <>
            <CartIcon />
            <LoginIcon />
          </>
        )}
        {onBurgerClick && (
          <BurgerMenuButton onClick={onBurgerClick} isOpen={isBurgerOpen} />
        )}
      </div>
    </div>
  );
};